import IconTextButton from "../Button/IconTextButton";
import { useLocation, useNavigate } from "react-router";

import ShoppingBasketOutlinedIcon from "@mui/icons-material/ShoppingBasketOutlined";
import ExitToAppOutlinedIcon from "@mui/icons-material/ExitToAppOutlined";

export default function PanierButton() {
	const navigate = useNavigate();
	const location = useLocation().pathname;

	return location.includes("panier") ? (
		<IconTextButton
			color="secondary"
			size="Large"
			icon={<ExitToAppOutlinedIcon />}
			onClick={() => navigate("./")}
		>
			Retour
		</IconTextButton>
	) : (
		<IconTextButton
			color="primary"
			size="Large"
			icon={<ShoppingBasketOutlinedIcon />}
			onClick={() => navigate("./mon_panier")}
		>
			Mon panier
		</IconTextButton>
	);
}
